module.exports = __webpack_public_path__ + "media/gateway/davivienda-checkout-678a5cb6.png";